import React from 'react';
import './RecipeBookPage.css';

const RecipeBookPage = () => {

  return (
    <div className="recipebook-page">
      <div className="container">
        
        {/* Hero Section */}
        <div className="recipebook-hero">
          <h1>RecipeBook</h1>
          <div className="hero-visual">
            <div className="recipe-preview">
              <div className="recipe-card">
                <div className="recipe-icon">📖</div>
                <div className="recipe-title">Delicious Recipes</div>
                <div className="recipe-stats">
                  <span>👥 Share</span>
                  <span>🔍 Search</span>
                  <span>➕ Create</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Project Overview */}
        <div className="project-section">
          <h2>About RecipeBook</h2>
          <p>
            RecipeBook is a full-stack web application developed for CS3550 at the University of Utah. 
            This comprehensive recipe management platform allows users to log in, edit recipes, upload new recipes, 
            and view recipes shared by other users in the community.
          </p>
          <p>
            The application emphasizes security, with comprehensive protection against common web vulnerabilities 
            including injection attacks and malicious user actions, ensuring a safe and secure experience for all users.
          </p>
        </div>

        {/* Technology Stack */}
        <div className="tech-section">
          <h2>Technologies Used</h2>
          <div className="tech-grid">
            <div className="tech-item">
              <div className="tech-icon">🐍</div>
              <span>Django</span>
            </div>
            <div className="tech-item">
              <div className="tech-icon">🌐</div>
              <span>HTML</span>
            </div>
            <div className="tech-item">
              <div className="tech-icon">🎨</div>
              <span>CSS</span>
            </div>
            <div className="tech-item">
              <div className="tech-icon">🟨</div>
              <span>JavaScript</span>
            </div>
          </div>
        </div>

        {/* Key Features */}
        <div className="features-section">
          <h2>Key Features</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🔍</div>
              <h3>Dynamic Search</h3>
              <p>Powerful search functionality that allows users to quickly find recipes by name, ingredients, or tags</p>
              <div className="feature-demo">
                <video controls playsInline>
                  <source src="/projects/recipebook/dynamicsearch_recipebook.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">➕</div>
              <h3>Create Recipes</h3>
              <p>User-friendly interface for creating and uploading new recipes with detailed instructions and ingredients</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">✏️</div>
              <h3>Edit Recipes</h3>
              <p>Full editing capabilities for users to modify their own recipes and keep them up to date</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">👥</div>
              <h3>Follow Recipes</h3>
              <p>Social features allowing users to follow favorite recipes and discover new ones from the community</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📱</div>
              <h3>Dynamic Sizing</h3>
              <p>Responsive design with dynamic sizing that adapts to different screen sizes and devices</p>
              <div className="feature-demo">
                <video controls playsInline>
                  <source src="/projects/recipebook/dynamicsizing_showcase_recipebook.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <h3>Secure Platform</h3>
              <p>Comprehensive security measures protecting against injection attacks and malicious actions</p>
            </div>
          </div>
        </div>

        {/* Technical Challenges */}
        <div className="challenges-section">
          <h2>Technical Challenges</h2>
          <div className="challenge-list">
            <div className="challenge-item">
              <div className="challenge-number">01</div>
              <div className="challenge-content">
                <h3>Full-Stack Development</h3>
                <p>Creating a complete full-stack application required careful coordination between Django backend and frontend JavaScript, ensuring seamless data flow and user experience</p>
              </div>
            </div>
            <div className="challenge-item">
              <div className="challenge-number">02</div>
              <div className="challenge-content">
                <h3>Error Handling & Validation</h3>
                <p>Implementing comprehensive error checking and validation when users create recipes, ensuring data integrity and preventing invalid submissions</p>
              </div>
            </div>
            <div className="challenge-item">
              <div className="challenge-number">03</div>
              <div className="challenge-content">
                <h3>Dynamic Search Implementation</h3>
                <p>Building an efficient and responsive dynamic search function that works seamlessly with the Django backend and provides real-time results</p>
              </div>
            </div>
            <div className="challenge-item">
              <div className="challenge-number">04</div>
              <div className="challenge-content">
                <h3>Security Implementation</h3>
                <p>Implementing robust security measures to protect against injection attacks and malicious user actions, ensuring the platform remains secure for all users</p>
              </div>
            </div>
          </div>
        </div>

        {/* Showcase Image */}
        <div className="showcase-section">
          <h2>Recipe Showcase</h2>
          <div className="showcase-image">
            <img src="/projects/recipebook/recipeshowcase_recipebook.png" alt="RecipeBook Showcase" />
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default RecipeBookPage;
